import { useNavigate } from 'react-router-dom'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '~/shadcn/ui/dialog'
import { ArrowForwardIcon } from '~/@mid_ui/icons/ArrowForwardIcon'
import { Button } from '~/shadcn/ui/button/button'

type Props = { open?: boolean; onClose(): void }

export function UnfinishedAnalysisDialog({ open = true, onClose }: Props) {
  const navigate = useNavigate()
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="w-[90vw] max-w-150">
        <DialogHeader>
          <DialogTitle
            title="Máte nedokončenú analýzu potrieb investora."
            className="text-2xl leading-9 font-semibold">
            Máte nedokončenú analýzu potrieb investora.
          </DialogTitle>
          <DialogDescription
            title="Aby sme vedeli prispôsobovať investičné produkty pre typ investora akým ste Vy, potrebujeme lepšie spoznať Vaše preferencie."
            className="font-medium">
            Aby sme vedeli prispôsobovať investičné produkty pre typ investora
            akým ste Vy, potrebujeme lepšie spoznať Vaše preferencie.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-5 sm:flex-row sm:items-center sm:justify-end">
          <Button variant="outline" className="" onClick={() => navigate('/')}>
            Odložiť na neskôr
          </Button>
          <Button
            variant="accent"
            className="flex-grow"
            size="lg"
            onClick={onClose}>
            <span>Pokračovať v otázkach</span>
            <ArrowForwardIcon className="ml-2" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
